import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import './App.less';
import AppLoadingScreen from './AppLoadingScreen';
import Login from './Pages/Login/Login';
import Dashboard from './Pages/Dashboard/Dashboard';
import MapMerchant from './Pages/Map/MapMerchant';
import Courses from './Pages/Courses/Courses';
import CourseAdd from './Pages/Courses/CourseAdd';
import AppLayout from './AppLayout';
import Profile from './Pages/Profile/Profile';
import Customers from './Pages/Customers/Customers';
import Stores from './Pages/Stores/Stores';
import { GlobalContext } from './GlobalContext';
import { AUTH_STATUS, ProvideAuth, useAuth } from './auth';

function PrivateRoute({component: Component, ...rest}) {
    const auth = useAuth();

    return (
        <Route
            {...rest}
            render={(props) => {
                if (auth.status === AUTH_STATUS.LOADING) {
                    return <AppLoadingScreen />;
                }

                if (auth.status !== AUTH_STATUS.AUTHENTICATED) {
                    return (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: {from: props.location},
                            }}
                        />
                    );
                }

                return (
                    <AppLayout onSignout={auth.signout}>
                        <Component {...props} />
                    </AppLayout>
                );
            }}
        />
    );
}

function PublicRoute({component: Component, ...rest}) {
    const auth = useAuth();

    return (
        <Route
            {...rest}
            render={(props) => {
                if (auth.status === AUTH_STATUS.LOADING && auth.loadingReason === 'bootstrap') {
                    return <AppLoadingScreen />;
                }

                return (auth.status === AUTH_STATUS.AUTHENTICATED) ? (
                    <Redirect
                        to={{
                            pathname: "/",
                        }}
                    />
                ) : (
                    <Component {...props} />
                );
            }}
        />
    );
}

function AppRoutes() {
    const auth = useAuth();
    const [global, updateGlobal] = useState({
        'profile': null,
        'config': null
    });

    useEffect(() => {
        updateGlobal((previousGlobal) => ({
            ...previousGlobal,
            profile: auth.user
        }));
    }, [auth.user]);

    const contextValue = {
        'global': global,
        'updateGlobal': updateGlobal
    };

    return (
        <GlobalContext.Provider value={contextValue}>
            <div className="App">
                <Switch>
                    <PublicRoute exact path='/login' component={Login}/>
                    <PrivateRoute exact path='/' component={Dashboard}/>
                    <PrivateRoute exact path='/map' component={MapMerchant}/>
                    <PrivateRoute exact path='/courses' component={Courses}/>
                    <PrivateRoute exact path='/course/add' component={CourseAdd}/>
                    <PrivateRoute exact path='/profile' component={Profile}/>
                    <PrivateRoute exact path='/customers' component={Customers}/>
                    <PrivateRoute exact path='/stores' component={Stores}/>
                </Switch>
            </div>
        </GlobalContext.Provider>
    );
}

function App() {
    return (
        <ProvideAuth>
            <Router>
                <AppRoutes />
            </Router>
        </ProvideAuth>
    );
}

export default App;
